import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import routes from "../routes";
// import { BrowserRouter as Router } from "react-router-dom";
import { Router } from "react-router-dom";
import { history } from "../history";

export default class Root extends Component {
  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <Router history={history}>{routes}</Router>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
